import React from "react";
import {
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Button,
  CircularProgress,
} from "@mui/material";
import { useSelector } from "react-redux";
import { getFromLocalStorage } from "../../../utils/webStorage";
const PrimaryStreamer = ({
  stageName,
  setStageName,
  leaveStage,
  handleStartStreaming,
  joining,
  connected,
  stopBtnLoading,
}) => {
  const userId = getFromLocalStorage("currentUserId");
  const cameraAngles = useSelector(
    (state) => state?.videoStreamData?.IPCameraAngles
  );
  const videoStreamAvsChannelList = useSelector(
    (state) => state?.videoStreamData?.videoStreamAvsChannelList
  );
  const primaryChannel = videoStreamAvsChannelList.find(
    (ele) => ele.isPrimaryChannel
  );
  const isPrimaryUser =
    !primaryChannel || primaryChannel.userId?.toString() === userId;

  return (
    <div>
      <FormControl fullWidth>
        <InputLabel id="angle-select-label">Select Angle</InputLabel>
        <Select
          labelId="angle-select-label"
          value={stageName}
          label="Camera Angle"
          onChange={(e) => setStageName(e.target.value)}
        >
          {cameraAngles.map((angle) => (
            <MenuItem key={angle.id} value={angle.angleName}>
              {angle.angleName}
            </MenuItem>
          ))}
        </Select>
        <div className="clear10" />
        <Button
          variant="contained"
          onClick={connected ? leaveStage : handleStartStreaming}
          disabled={joining}
        >
          {joining ? (
            <CircularProgress size={20} sx={{ color: "#fff" }} />
          ) : connected ? (
            "STOP STREAMING"
          ) : (
            "START STREAMING"
          )}
        </Button>
        <div className="clear10" />
        {videoStreamAvsChannelList.length != 0 &&
          !connected &&
          isPrimaryUser && (
            <Button variant="contained" onClick={leaveStage} disabled={joining}>
              {stopBtnLoading ? (
                <CircularProgress size={20} sx={{ color: "#fff" }} />
              ) : (
                "STOP CHANNEL"
              )}
            </Button>
          )}
      </FormControl>
    </div>
  );
};

export default PrimaryStreamer;
